module.exports = __webpack_public_path__ + "fd0c2b46a69c3471522024edf6874e33.svg";